export const TemplatesActions = {
    FETCH_TEMPLATE_NAMES: 'FETCH_TEMPLATE_NAMES',
    FETCH_SINGLE_TEMPLATE: 'FETCH_SINGLE_TEMPLATE',
    FETCH_SINGLE_TEMPLATE_RETURN: 'FETCH_SINGLE_TEMPLATE_RETURN',
    CLEAR_SINGLE_TEMPLATE: 'CLEAR_SINGLE_TEMPLATE'
};

export const fetchTemplates = payload => ({
    type: TemplatesActions.FETCH_TEMPLATE_NAMES,
    payload
});

export const fetchSingleTemplate = payload => ({
    type: TemplatesActions.FETCH_SINGLE_TEMPLATE,
    payload
});

export const fetchSingleTemplateReturn = payload => ({
    type: TemplatesActions.FETCH_SINGLE_TEMPLATE_RETURN,
    payload
});

export const clearSingleTemplate = () => ({
    type: TemplatesActions.CLEAR_SINGLE_TEMPLATE
});
